export const CrazySDK = (window as any).CrazyGames?.SDK;
